import React from 'react';
import GenericFilter from './GenericFilter';

const LiveViewClientsFilter = (props) => <GenericFilter {...props} titleKey="clients" namePrefix="client" />;

export default LiveViewClientsFilter;
